import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Adminnavbar from "../Components/Adminnavbar";
import {
  FaExchangeAlt,
  FaDollarSign,
  FaUserCog,
  FaClock,
  FaCheck,
  FaTimes,
} from "react-icons/fa";
import { useDataContext } from "../Context/dataContext";
import { FaEye, FaSearch } from "react-icons/fa";
import { Modal, ModalHeader, ModalBody, FormGroup } from "reactstrap";
import { NotFound } from "./NotFound";

function UserPortal() {
  const { url, infoTkn } = useDataContext();

  const [admin, setAdmin] = useState({});
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [currency, setCurrency] = useState([]);

  const [usdtToday, setUsdtToday] = useState(0);
  const [bsToday, setBsToday] = useState(0);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [totalUsdt, setTotalUsdt] = useState(0);
  const [totalBs, setTotalBs] = useState(0);

  const [currencyBs, setCurrencyBs] = useState([]);

  const [searching, setSearching] = useState(false);

  const fetchCurrencyBs = useCallback(async () => {
    try {
      const response = await axios.get(`${url}/currency-price/1`, {
        headers: {
          Authorization: `Bearer ${infoTkn}`,
        },
      });
      setCurrencyBs(response.data.cur_bs);
    } catch (error) {
      console.log(error);
    }
  }, [infoTkn, url]);

  const fetchDataAdmin = useCallback(async () => {
    try {
      const response = await axios.get(
        `${url}/Auth/findByJWTAdmin/${infoTkn}`,
        {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
          },
        }
      );
      setAdmin(response.data.data);

      const responseUsdt = await axios.get(
        `${url}/Movements/total/totalUsdtPaidByAdmin/${response.data.data.adm_id}`,
        {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
          },
        }
      );
      setUsdtToday(responseUsdt.data);

      const responseBs = await axios.get(
        `${url}/Movements/total/totalBsPaidByAdmin/${response.data.data.adm_id}`,
        {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
          },
        }
      );
      setBsToday(responseBs.data);

      const responseMovements = await axios.get(
        `${url}/Movements/admin/${response.data.data.adm_id}`,
        {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
          },
        }
      );
      setOrders(responseMovements.data);
      setFilteredOrders(responseMovements.data); // Inicializar con todas las órdenes
    } catch (error) {
      console.log(error);
    }
  }, [infoTkn, setAdmin, url]);

  const fetchCurrency = async () => {
    try {
      const response = await axios.get(
        "https://api.coingecko.com/api/v3/simple/price?ids=tether&vs_currencies=eur"
      );
      setCurrency(response.data.tether.eur);
    } catch (error) {
      console.error(error);
    }
  };

  const filterOrdersByDate = () => {
    setSearching(true);
    const filtered = orders.filter((order) => {
      const orderDate = new Date(order.mov_paymentDate);
      const start = new Date(startDate);
      const end = new Date(endDate);
      return orderDate >= start && orderDate <= end;
    });
    setFilteredOrders(filtered);
    calculateTotals(filtered);
  };

  const calculateTotals = (filtered) => {
    let totalUsdt = 0;
    let totalBs = 0;

    filtered
      .filter((order) => order.mov_status === "V")
      .forEach((order) => {
        if (order.mov_conversionType === "Usdt") {
          totalUsdt += order.mov_paymentAmount;
        } else if (order.mov_conversionType === "Bs") {
          totalBs += order.mov_paymentAmount;
        }
      });

    setTotalUsdt(totalUsdt);
    setTotalBs(totalBs);
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const [modalReject, setModalReject] = useState(false);
  const [modalRejectComment, setModalRejectComment] = useState("");

  const openModal = (image) => {
    setSelectedImage(image);
    setModalOpen(true);
  };

  const openModalReject = (comment) => {
    setModalRejectComment(comment);
    setModalReject(true);
  };

  useEffect(() => {
    fetchCurrency();
    fetchDataAdmin();
    fetchCurrencyBs();
  }, [fetchCurrencyBs, fetchDataAdmin]);

  return admin ? (
    <div>
      <Adminnavbar />
      <div className="user-portal">
        {/* Header de bienvenida */}
        <div className="order-header">
          <div className="order-header__date">
            <FaExchangeAlt className="order-header__icon" />
            <span>{new Date().toLocaleDateString("es-ES")}</span>
          </div>
          <div className="order-header__welcome">
            <FaUserCog className="order-header__icon" />
            <span>
              Bienvenido, <strong>{admin.adm_user}</strong>
            </span>
          </div>
        </div>

        {/* Tarjetas de Totales */}
        <div className="stats-container">
          {/* Tarjeta Total USDT Cambiados */}
          <div className="stat-card blue">
            <FaDollarSign className="stat-icon" />
            <h3>USDT</h3>
            <p>{usdtToday.total ? usdtToday.total.toFixed(2) : 0} Usdt</p>
            <span className="subtext">Transacciones del día</span>
          </div>

          {/* Tarjeta Total Bolívares Cambiados */}
          <div className="stat-card green">
            <FaDollarSign className="stat-icon" />
            <h3>Bolívares</h3>
            <p>{bsToday.total ? bsToday.total.toFixed(2) : 0} Bs</p>
            <span className="subtext">Transacciones del día</span>
          </div>

          {/* Tarjeta Tasa Oficial */}
          <div className="stat-card purple">
            <FaExchangeAlt className="stat-icon" />
            <h3>Tasa Oficial</h3>
            <p>{currency}</p>
            <span className="subtext">Referencia del mercado</span>
          </div>

          {/* Tarjeta Tasa Objetiva */}
          <div className="stat-card orange">
            <FaExchangeAlt className="stat-icon" />
            <h3>Tasa Objetiva</h3>
            <p>{currency * admin.adm_porcent + currency}</p>
            <span className="subtext">Valor calculado</span>
          </div>
        </div>

        <div className="date-query">
          <h3 className="date-query__title">📅 Consulta de Fechas</h3>

          {/* Campos de fecha */}
          <div className="date-query__input">
            <div className="date-query__field">
              <label htmlFor="start-date">Desde: </label>
              <input
                type="date"
                id="start-date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="date-query__field">
              <label htmlFor="end-date">Hasta: </label>
              <input
                type="date"
                id="end-date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>

          <FormGroup>
            <button className="date-query__button" onClick={filterOrdersByDate}>
              <FaSearch className="date-query__icon" /> Buscar
            </button>
            {"  "}
            <button
              className="date-query__button"
              onClick={() => {
                window.location.reload();
                setSearching(false);
              }}
            >
              <FaSearch className="date-query__icon" /> Limpiar
            </button>
          </FormGroup>

          {/* Sección de Totales */}
          <div className="date-query__totals">
            <div className="date-query__total">
              <span>Total Usdt Cambiados:</span>
              <span className="rate-value"> Usdt {totalUsdt.toFixed(2)}</span>
            </div>
            <div className="date-query__total">
              <span>Total Bolívares:</span>
              <span className="rate-value">Bs. {totalBs.toFixed(2)}</span>
            </div>
          </div>
        </div>

        {/* Tabla de Transacciones Pendientes */}
        <div className="transactions-table">
          <h3>📌 Transacciones</h3>
          <table className="orders-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Usuario</th>
                <th>Monto en Euros</th>
                <th>Monto en USDT / Bs.</th>
                <th>Tasa Oficial</th>
                <th>Tasa Objetiva</th>
                <th>Estado</th>
                <th>Detalles</th>
              </tr>
            </thead>

            <tbody>
              {filteredOrders
                .filter((order) => {
                  if (!searching) {
                    console.log(new Date().toISOString().split("T")[0]);
                    return (
                      order.mov_status === "P" ||
                      order.mov_paymentDate ===
                        new Date().toISOString().split("T")[0]
                    );
                  }
                  return true;
                })
                .map((transaction, index) => (
                  <tr key={index + 1}>
                    <td>{index + 1}</td>
                    <td>
                      {transaction.User.use_name}{" "}
                      {transaction.User.use_lastName}
                    </td>
                    <td>{transaction.mov_amount} €</td>
                    {transaction.mov_conversionType === "Usdt" &&
                      (transaction.mov_status !== "V" ? (
                        <td>
                          {(
                            transaction.mov_amount /
                            (transaction.mov_conversionRate *
                              admin.adm_porcent +
                              transaction.mov_conversionRate)
                          ).toFixed(2)}{" "}
                          Usdt
                        </td>
                      ) : (
                        <td>{transaction.mov_paymentAmount} Usdt</td>
                      ))}
                    {transaction.mov_conversionType === "Bs" &&
                      (transaction.mov_status !== "V" ? (
                        <td>
                          {(
                            (transaction.mov_amount /
                              (currency * admin.adm_porcent + currency)) *
                            transaction.mov_conversionRate
                          ).toFixed(2)}{" "}
                          Bs
                        </td>
                      ) : (
                        <td>{transaction.mov_paymentAmount} Bs</td>
                      ))}
                    {transaction.mov_conversionType === "Usdt" && (
                      <td>1 Eur = {currency} Usdt</td>
                    )}
                    {transaction.mov_conversionType === "Bs" && (
                      <td>1 Usdt = {currencyBs.toFixed(2)} Bs</td>
                    )}
                    <td>{currency * admin.adm_porcent + currency}</td>
                    <td className={`status`}>
                      {transaction.mov_status === "P" && (
                        <FaClock className="status-icon pending" />
                      )}
                      {transaction.mov_status === "V" && (
                        <FaCheck className="status-icon verified" />
                      )}
                      {transaction.mov_status === "R" && (
                        <FaTimes className="status-icon rejected" />
                      )}
                      {transaction.mov_status === "P" && "En espera"}
                      {transaction.mov_status === "V" && "Verificado"}
                      {transaction.mov_status === "R" && "Rechazado"}
                    </td>
                    {transaction.mov_status !== "R" && (
                      <td>
                        {transaction.mov_conversionType === "Usdt" ? (
                          <span className="hash">
                            {transaction.mov_paymentProof}
                          </span>
                        ) : (
                          transaction.mov_status === "V" && (
                            <button
                              className="view-proof-btn"
                              onClick={() => openModal(transaction)}
                            >
                              <FaEye />
                            </button>
                          )
                        )}
                      </td>
                    )}
                    {transaction.mov_status === "R" && (
                      <td>
                        <button
                          className="view-proof-btn"
                          onClick={() =>
                            openModalReject(transaction.mov_paymentComment)
                          }
                        >
                          <FaEye />
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        <Modal
          isOpen={modalReject}
          toggle={() => setModalReject(false)}
          centered
        >
          <ModalHeader toggle={() => setModalReject(false)}>
            Comentario de Rechazo
          </ModalHeader>
          <ModalBody>
            <p>{modalRejectComment}</p>
          </ModalBody>
        </Modal>

        <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} centered>
          <ModalHeader toggle={() => setModalOpen(false)}>
            Comprobante de Pago
          </ModalHeader>
          <ModalBody>
            {selectedImage &&
              selectedImage.mov_paymentProof.includes(".pdf" || ".PDF") && (
                <a
                  href={`${url}/Movements/paymentProof/${selectedImage.mov_paymentProof}`}
                  target="_blank"
                  without
                  rel="noreferrer"
                  download
                >
                  Descargar PDF
                </a>
              )}
            {selectedImage &&
              !selectedImage.mov_paymentProof.includes(".pdf" || ".PDF") && (
                <img
                  style={{ width: "100%" }}
                  alt="Comprobante"
                  className="proof-image"
                  src={`${url}/Movements/paymentProof/${selectedImage.mov_paymentProof}`}
                />
              )}
          </ModalBody>
        </Modal>
      </div>
    </div>
  ) : (
    <NotFound />
  );
}

export { UserPortal };
